import { Link } from "react-router-dom";

// Renders a string with inline markdown links [text](/path).
// Internal links (starting with /) use react-router Link; others open in a new tab.
export const RichText = ({ text, className = "" }) => {
  const parts = [];
  const regex = /\[([^\]]+)\]\(([^)]+)\)/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const [, label, href] = m;
    if (href.startsWith("/")) {
      parts.push(
        <Link key={i++} to={href} className="font-medium text-brand-blue hover:underline">
          {label}
        </Link>
      );
    } else {
      parts.push(
        <a key={i++} href={href} target="_blank" rel="noopener noreferrer" className="font-medium text-brand-blue hover:underline">
          {label}
        </a>
      );
    }
    last = regex.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <p className={className}>{parts}</p>;
};
